import { Navigate, Outlet, useParams } from 'react-router';
import { useStoredInspection } from '../../hooks/useStoredInspection';
import { inspectionRecordService } from '../../services/inspection/inspectionRecordService';

/**
 * Wraps the editing screens: a submitted Inspection is sent to the read-only view,
 * however the screen was reached, so it can only change after Reopen (#11590, SY-13).
 */
export const SubmittedInspectionGuard = () => {
  const { externalId = '' } = useParams<{ externalId: string }>();
  const inspection = useStoredInspection(externalId);

  // Nothing is shown until the state is known, so an editor never opens on a submitted one.
  if (inspection === undefined) return null;

  if (inspection && inspectionRecordService.isSubmitted(inspection)) {
    return <Navigate to={`/inspections/${externalId}/complete`} replace />;
  }

  return <Outlet />;
};
